/* eslint-disable import/no-webpack-loader-syntax */
import * as Comlink from "comlink";
const postDataWorker = require("worker-loader!./postData.js");
export async function postData({ field, payload, user_id, pk }) {
  const worker = new postDataWorker();
  const service = Comlink.wrap(worker);
  return await service.postData({ field, payload, user_id, pk });
}
